import type { DOMOutputSpec } from "@tiptap/pm/model";

/**
 * Replace a spec's content hole (`0`) with `replacement` (which must contain its own `0`),
 * following the last child at each nesting level.
 */
export function replaceContentHole(spec: DOMOutputSpec, replacement: DOMOutputSpec): DOMOutputSpec {
  if (!Array.isArray(spec)) {
    return spec;
  }

  const next = [...(spec as readonly unknown[])];
  const last = next[next.length - 1];

  if (last === 0) {
    next[next.length - 1] = replacement;
  } else if (Array.isArray(last)) {
    next[next.length - 1] = replaceContentHole(last as unknown as DOMOutputSpec, replacement);
  }

  return next as unknown as DOMOutputSpec;
}
